import { ref } from 'vue'

export const deliveryBus = ref(false)
